import styled, { keyframes } from "styled-components";
import { mediaQueries } from "../shared/config";
import DBHeader from '../components/Header.js';
import { useRef, useState, useCallback, useEffect } from 'react';
import Slideshow from './Slideshow-nocross';
import Landing from "./Landing-nohead";

import PowellDesktop from '../assets/landing_desktop.gif';
import PowellMobile from '../assets/landing_mobile.gif';
import mobileImage from '../assets/Group 214.svg';
import gradCapsBottom from '../assets/grad caps.svg';
import GradCapFooter from './Landing-nohead';
const RenderGIF = styled("img")`
  width: 100%;
  height: 100vh;
  ${mediaQueries.mobile} {
    /* height: 100px; */
  }
`;

function GifWithLanding (props) {
  let myRef = useRef(null);
  let data = props.data;

  const [firstTime, setFirstTime] = useState(true);
  const media = window.matchMedia('(max-width: 700px)')
  const [isMobile, setIsMobile] = useState(media.matches)

  media.addEventListener("change", () => {
    if (media.matches !== isMobile) {
      setIsMobile(media.matches)
    }
  })

  const scroller = useCallback(() => {
    setTimeout(() => {
      if (myRef && myRef.current) {
        myRef.current.scrollIntoView({behavior: 'smooth'})
        setFirstTime(false)
      }
    }, 5000)
  }, [myRef])

  return (
      <>
        <DBHeader/>
        {isMobile ? (
          <RenderGIF src={PowellMobile}></RenderGIF>
        ) : (
          <RenderGIF src={PowellDesktop}></RenderGIF>
        )}
        <div ref={myRef}>
          <Slideshow  data={data} /> 
        </div>
        <Landing/>
        { firstTime ? scroller() : null }
      </>
  );
}

export default GifWithLanding;